export const APP = {
  NAME: 'ARMA AI',
  TITLE: 'ARMA AI - AI-Native Regulatory & Supervisory Platform',
  VERSION: 'v2.1.0-stable',
  USER: {
    NAME: '@Wen',
    INITIALS: 'WG',
    ROLE: 'Principal Operator',
  },
} as const;

export const appConstants = {
  page: 0,
  limit: 50,

} as const;

